import React, { useState } from "react";
import LayoutNav from "containers/LayoutNav";
import { useDispatch, useSelector } from "react-redux";

import { setEditCurrentView } from "store/actions/charts";
import { updateSidePanelAction } from "store/actions/sidepanel";

import { extractSystemId } from "utils/utils";
import { SYSTEMS_PAGES } from "constants/pages.constant";

import { CHART_HEADER_ACTIONS } from "../../../constants/chartConstant";

import "./index.scss";

const ChartSideNav = props => {
  const { currentEditView, setCurrentEditView, setTagValue, setNormalizedTagConfig } = props;
  const systemID = extractSystemId();

  const dispatch = useDispatch();
  const { isChartPanelOpened } = useSelector(state => state.sidePanelData);

  const [isAddLayoutFormOpen, setIsAddLayoutFormOpen] = useState(false);
  const [isEditLayoutFormOpen, setIsEditLayoutFormOpen] = useState(false);
  const [isAddWidgetFormOpen, setIsAddWidgetFormOpen] = useState(false);

  const isNormalizedTagOpen = () =>
    currentEditView === CHART_HEADER_ACTIONS.EDIT_NORMALIZE_FILTERS || currentEditView === CHART_HEADER_ACTIONS.ADD_NORMALIZE_TAG;

  const onToggleCollapsedNav = () => {
    const isSidePanelOpened = !isChartPanelOpened && !isNormalizedTagOpen();
    dispatch(updateSidePanelAction({ isChartPanelOpened: isSidePanelOpened }));
    setCurrentEditView(CHART_HEADER_ACTIONS.NONE);
    setIsAddLayoutFormOpen(false);
    setIsAddWidgetFormOpen(false);
    setIsEditLayoutFormOpen(false);
    dispatch(setEditCurrentView(CHART_HEADER_ACTIONS.NONE));
    setTagValue(null);
    setNormalizedTagConfig(null);
  };

  return (
    <div className="sideNavMainContainer">
      <div
        className={`sideNavMenubutton ${
          isChartPanelOpened || isNormalizedTagOpen() ? "sideNavOpenMenuwidth sideNavCloseMenuButton" : "sideNavCloseMenuwidth sideNavOpenMenuButton"
        }`}
        onClick={onToggleCollapsedNav}
      />
      {isChartPanelOpened && (
        <div className="sideNavMenuOpen">
          <LayoutNav
            page={SYSTEMS_PAGES.CHARTS}
            systemID={systemID}
            //setIsChartRerendering={onChartLayoutUpdate}
            isAddLayoutFormOpen={isAddLayoutFormOpen}
            setIsAddLayoutFormOpen={setIsAddLayoutFormOpen}
            isEditLayoutFormOpen={isEditLayoutFormOpen}
            setIsEditLayoutFormOpen={setIsEditLayoutFormOpen}
            isAddWidgetFormOpen={isAddWidgetFormOpen}
            setIsAddWidgetFormOpen={setIsAddWidgetFormOpen}
          />
        </div>
      )}
    </div>
  );
};

export default ChartSideNav;
